// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--PJ9w2fyNU_gXV4Fp"};